import { useQuery } from 'react-query'; 
import axiosInstance from './axiosInstance';

const fetchClient = async (id) => {
  if (!id) throw new Error("Client ID is required");
  const response = await axiosInstance.get(`/super-admin/client-management/client/${id}`);
  return response.data?.payload;
};

export const useGetClient = (id) => {
  return useQuery(
    ['client', id],
    () => fetchClient(id),
    {
      enabled: !!id, 
      staleTime: 5 * 60 * 1000,
      retry: 1, 
    }
  );
};
